<template>
  <div class="myCenterCommon__userContent__2fHEF">
    <div class="myCenterCommon__users_layout__title__3CoQ0">
      <h3>消息中心</h3>
      <span></span>
    </div>
    <div class="userInfo__users_layout_form__HFPCL">
      <div role="tablist" aria-multiselectable="true" class="el-collapse" v-if="false">
        <div class="el-collapse-item is-active">
          <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-3213" aria-describedby="el-collapse-content-3213">
            <div role="button" id="el-collapse-head-3213" tabindex="0" class="el-collapse-item__header is-active">遵守<i class="el-collapse-item__arrow el-icon-arrow-right is-active"></i></div>
          </div>
          <div role="tabpanel" aria-labelledby="el-collapse-head-3213" id="el-collapse-content-3213" class="el-collapse-item__wrap">
            <div class="el-collapse-item__content">
              <div><p>请自觉遵守本站秩序</p></div>
              <div>发布时间：2021-10-12 15:09:06</div>
            </div>
          </div>
        </div>
      </div>
      <el-tabs v-model="type">
        <el-tab-pane label="公告" name="0">
          <div  role="tablist" aria-multiselectable="true" class="el-collapse" v-for="(item, index) in homenoticelis" :key="index" >
            <div  class="el-collapse-item is-active">
              <div role="tab" aria-controls="el-collapse-content-2341" aria-describedby="el-collapse-content-2341" aria-expanded="true">
                <div role="button" id="el-collapse-head-2341" tabindex="0" class="el-collapse-item__header is-active"></div>
              </div>
              <div role="tabpanel" aria-labelledby="el-collapse-head-2341" id="el-collapse-content-2341" class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom="" data-old-overflow="" style="">
                <div class="el-collapse-item__content">
                  <div >{{item}}</div>
                  <div ></div>
                </div>
              </div>
            </div>
          </div>

   
        </el-tab-pane>
        <el-tab-pane label="站内信" name="1">
            <div  role="tablist" aria-multiselectable="true" class="el-collapse" v-for="(item, index) in noticeList" :key="index" >
            <div  class="el-collapse-item is-active">
              <div role="tab" aria-controls="el-collapse-content-2341" aria-describedby="el-collapse-content-2341" aria-expanded="true">
                <div role="button" id="el-collapse-head-2341" tabindex="0" class="el-collapse-item__header is-active">{{item.title}}</div>
              </div>
              <div role="tabpanel" aria-labelledby="el-collapse-head-2341" id="el-collapse-content-2341" class="el-collapse-item__wrap" data-old-padding-top="" data-old-padding-bottom="" data-old-overflow="" style="">
                <div class="el-collapse-item__content">
                  <div v-html="item.content"></div>
                  <div >{{ item.created_at }}</div>
                </div>
              </div>
            </div>
          </div>
 
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      type: 0,
      noticeList: [],
      homenoticelis: [],
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }
    that.$parent.showLoading();
    that.homenotice();
    that.getDatalist();
  },
  methods: {
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/main_493df0b3.71306a96.css';
// @import '../../../static/css/leyuCenterLeft_81ba8019.8ac3706f.css';
// @import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';

</style>



// WEBPACK FOOTER //
// src/components/mine/message.vue